import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <a className="App-link" target="_blank" rel="noopener noreferrer">
          airModules Theme Service UI
        </a>
        <small>under construction</small>
      </header>
    </div>
  );
}

export default App;
